import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function IncorrectPasswordDialog({ onDismiss, isOpen }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      heading={t("auth.incorrectPasswordDialog.heading")}
      text={t("auth.incorrectPasswordDialog.text")}
      type="failure"
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
